export enum StoreDeletionEnum {
    SEAM_REQUESTS = 'seamRequests',
    CORRECTION_PATTERNS = 'correctionPatterns',
    OLD_STORE_MAPS = 'oldStoreMaps',
    PARTNER_MAPS = 'partnerMaps',
    PARTNER_MAP_QUERIES = 'partnerMapQueries',
    PARTNER_MAP_QUERY_MODS = 'partnerMapQueryMods',
    ATTRIBUTES = 'attributes',
    KEYWORDS = 'keywords',
    SPEND_METRICS = 'spendMetrics',
    ABBREVIATIONS = 'abbreviations',
    MODEL_TRAINING = 'modelTraining',
}
